import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../Button.js';
import { useTranslation } from 'react-i18next';


function SectionTable({ title, headers, rows, emptyMsg, viewAllLink }) {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 md:p-5 mb-4">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-base font-semibold text-gray-800">{title}</h2>
        {viewAllLink && (
          <Button
            variant="link"
            onClick={() => navigate(viewAllLink)}
          >
            View All →
          </Button>
        )}
      </div>
      {rows.length > 0 ? (
        <>
          <div className="md:hidden space-y-3">
            {rows.map((row, ri) => (
              <div key={ri} className="rounded-lg border border-gray-100 bg-gray-50/60 p-3 space-y-2">
                {headers.map((h, ci) => (
                  <div key={ci} className="flex items-start justify-between gap-3 text-sm">
                    <span className="text-gray-500 text-xs font-medium uppercase tracking-wide shrink-0">{h}</span>
                    <span className="text-gray-800 text-right break-words">{row[ci] ?? '-'}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
          <div className="hidden md:block overflow-x-auto -mx-4 md:-mx-5">
            <table className="w-full text-sm min-w-[500px]">
              <thead className="bg-gray-50/80 border-b border-gray-200">
                <tr>
                  {headers.map((h, i) => (
                    <th key={i} className="px-4 py-2.5 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {rows.map((row, ri) => (
                  <tr key={ri} className="hover:bg-gray-50/50 transition-colors">
                    {row.map((cell, ci) => (
                      <td key={ci} className="px-4 py-2.5 text-sm text-gray-700 whitespace-nowrap">
                        {cell ?? '-'}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <p className="text-gray-400 text-sm text-center py-6">{emptyMsg}</p>
      )}
    </div>
  );
}

export default SectionTable;
